import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'

import * as layer from './layer'
import { calculateExtent, createExtentFromPixel } from '../utils/extent'

export let isOffline = false

export const offlineVectorSource = new VectorSource()
export const optOfflineVectorSource = new VectorSource()

export function init(client) {
  client.map.on('singleclick', e => onSingleclick(client, e))
}

export function toggle(client) {
  isOffline = !isOffline
  client.autoSelection.featureSelection.clearFeatures()
  client.autoSelection.popup.destroy()
  client.config.layers.forEach(layer => {
    if (layer.metadata && layer.metadata.alwaysOnline) {
      return
    }
    const mapLayer = layer.mapLayer_
    const offlineLayer = layer.offlineLayer_

    if (mapLayer instanceof VectorLayer) {
      mapLayer.setVisible(layer.visible)
    } else {
      mapLayer.setVisible(!isOffline && layer.visible)
    }

    if (offlineLayer) offlineLayer.setVisible(isOffline && layer.visible)
  })
  trigger(isOffline ? 'offline' : 'online')
  return isOffline
}

function onSingleclick(client, e) {
  if (!isOffline || !client.autoSelection.active) return true
  const features = []
  const extent = createExtentFromPixel(e.map, e.pixel, 15)

  offlineVectorSource.forEachFeatureIntersectingExtent(extent, f => {
    if (f.get('olga_').layer.visible && f.get('olga_').layer.metadata.identify)
      features.push(f)
    return false
  })
  optOfflineVectorSource.forEachFeatureIntersectingExtent(extent, f => {
    const isAdded = features.some(
      fo =>
        fo.get('olga_').name === f.get('olga_').name &&
        fo.get('objectid') === f.get('objectid')
    )
    if (f.get('olga_').layer.visible && !isAdded) features.push(f)
    return false
  })
  if (features.length > 0) {
    features.sort(
      (a, b) => a.get('olga_').layer.index_ < b.get('olga_').layer.index_
    )
    client.autoSelection.showPopup(features, e.coordinate)
    return false
  }
  return true
}

export function activate(client, offlinePackage) {
  offlineVectorSource.clear()
  client.config.layers.forEach(l => layer.attach(client.map, l, offlinePackage))

  // If we have TOC - rerender to make sure it is in sync with the layers
  if (client.layers) {
    client.layers.ui.render()
  }
}

const callbacksMap = {
  offline: [],
  online: []
}

export function on(event, callback) {
  callbacksMap[event].push(callback)
}

export function trigger(event, data) {
  callbacksMap[event].forEach(callback => callback(data))
}
